import React, { useEffect, useState } from "react";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Button from "@mui/material/Button";
import Box from "@mui/material/Box";
import DoNotDisturbIcon from "@mui/icons-material/DoNotDisturb";
import CheckIcon from "@mui/icons-material/Check";
import { getData, postData } from "../api/AuthenticatedApiCaller";
import { InsuranceApi, TraitsApi } from "../api/AdminApi";
import TableContainer from "@mui/material/TableContainer";
import { IconButton } from "@mui/material";
import EditIcon from "@mui/icons-material/Edit";
import InsuranceAddDialog from "./InsuranceAddDialog";

export default function InsuranceView() {
  const [insurances, setInsurances] = useState(null);
  const [update, setUpdate] = useState(true);
  const [isDialogOpen, setIsDialogOpen] = useState(false);
  const [editedInsurance, setEditedInsurance] = useState(null);

  async function fetchData() {
    const [data, error] = await getData(InsuranceApi.findAll);
    if (error) {
      // Handle the error
    } else {
      console.log(data)
      setInsurances(data);
    }
  }

  async function setIsDefault(id, isDefault) {
    const [data, error] = await postData(
      InsuranceApi.setIsDefault + "?id=" + id + "&isDefault=" + isDefault
    );
    if (error) {
      // Handle the error
    } else {
      setUpdate(true);
    }
  }

  useEffect(() => {
    if (insurances === null || update) {
      fetchData();
    }
    setUpdate(false);
  }, [update]);

  return (
    <Box>
      {insurances !== null  && (
        <InsuranceAddDialog
         languages={insurances.languages}
          open={isDialogOpen}
          insurance={editedInsurance}
          save={() => {
            setIsDialogOpen(false);
            setUpdate(true);
          }}
          cancel={() => setIsDialogOpen(false)}
        />
      )}

      <Button
        onClick={() => {
          setEditedInsurance(null);
          setIsDialogOpen(true);
        }}
        variant="contained"
      >
        Add Insurance
      </Button>

      <TableContainer>
        <Table sx={{ minWidth: 650 }}>
          <TableHead>
            <TableRow key="header">
              <TableCell>Id</TableCell>
              <TableCell>Title</TableCell>
              <TableCell>Excess</TableCell>
              <TableCell>Price/day</TableCell>
              {insurances !== null &&
                insurances.languages.map((lang) => (
                  <TableCell>Text{lang}</TableCell>
                ))}
              <TableCell>Default Insurance</TableCell>
              <TableCell>Edit</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {insurances !== null &&
              insurances["data"].map((insurance) => (
                <TableRow id={insurance.id}>
                  <TableCell>{insurance.id}</TableCell>
                  <TableCell>{insurance.title}</TableCell>
                  <TableCell>{insurance.excess}</TableCell>
                  <TableCell>{insurance.pricePerDay}</TableCell>
                  {insurance.contents.map((content) => (
                    <TableCell>{content.text}</TableCell>
                  ))}
                  {insurance.defaultInsurance !== true ? (
                    <TableCell>
                      <IconButton>
                        <DoNotDisturbIcon
                          onClick={() => setIsDefault(insurance.id, true)}
                        />
                      </IconButton>
                    </TableCell>
                  ) : (
                    <TableCell>
                      <IconButton>
                        <CheckIcon
                          onClick={() => setIsDefault(insurance.id, false)}
                        />
                      </IconButton>
                    </TableCell>
                  )}

                  <TableCell>
                    <IconButton>
                      <EditIcon
                        onClick={() => {
                          setEditedInsurance(insurance);
                          setIsDialogOpen(true);
                        }}
                      />
                    </IconButton>
                  </TableCell>
                </TableRow>
              ))}
          </TableBody>
        </Table>
      </TableContainer>
    </Box>
  );
}
